export enum EncryptionMode {
  Encrypted = 'Encrypted',
  AutoDecrypted = 'AutoDecrypted'
}
